import type { QuestionCounts } from '../lib/questionCounts';

export { formatCount } from '../lib/questionCounts';

const STATIC_COUNTS: QuestionCounts = {
  sat: { total: 2500, math: 1245, english: 1255 },
  act: { total: 2590, english: 600, math: 950, reading: 540, science: 500 },
  apPhysics: { total: 650 },
  apCalc: { total: 610 },
  grand: 2500,
};

export function useQuestionCounts() {
  return STATIC_COUNTS;
}
